import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { PlatformShareCard } from "./PlatformShareCard";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const PlatformSharePage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;

  return (
    <PageContainer title="Active Users by Platform">
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">Active users by Platform</Typography>
          <DateRangeNav dateRange={dateRange} />
        </Box>
        <PlatformShareCard startDate={startDate} endDate={endDate} />
      </Paper>
    </PageContainer>
  );
};

export default PlatformSharePage;
